// @flow
/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import type { LocationState } from 'redux-first-router';

import type { AppState } from 'store/types';

import * as c from './constants';

export const rootModule = (state: AppState): LocationState => state[c.MODULE_NAME];

export const type = createSelector([rootModule], (state) => state.type);
export const pathname = createSelector([rootModule], (state) => state.pathname);
export const payload = createSelector([rootModule], (state) => state.payload);
export const query = createSelector([rootModule], (state) => state.query);
export const search = createSelector([rootModule], (state) => state.search);

const prev = createSelector([rootModule], (state) => state.prev);

export const prevType = createSelector([prev], (state) => state.type);
export const prevPathname = createSelector([prev], (state) => state.pathname);
export const prevPayload = createSelector([prev], (state) => state.payload);
export const prevQuery = createSelector([prev], (state) => state.query);
export const prevSearch = createSelector([prev], (state) => state.search);



// WEBPACK FOOTER //
// ./src/modules/router/selectors.js